import React from 'react';

function BrandGuideEditor({ value, onChange }) {
  return (
    <div className="form-group">
      <label className="form-label">Brand Guide (Markdown)</label>
      <textarea
        className="brand-guide-editor"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="# Brand Guide&#10;&#10;Escreva o brand guide do cliente em Markdown..."
      />
    </div>
  );
}

export default BrandGuideEditor;
